export default __webpack_public_path__ + "static/media/secret_pay_offline.bb541331.svg";